import React from 'react';
import SkeletonCard from './skeleton-card';

interface SkeletonFeedProps {
  count?: number;
  variant?: 'post' | 'community' | 'user' | 'product';
  className?: string;
}

const SkeletonFeed: React.FC<SkeletonFeedProps> = ({ 
  count = 3, 
  variant = 'post',
  className = '' 
}) => {
  return (
    <div className={`space-y-4 ${className}`}>
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonCard key={index} variant={variant} />
      ))}
    </div>
  );
};

export default SkeletonFeed;